import React, { useRef } from 'react';
import { loadGist } from './InnerHtmlGist';
export const Context = React.createContext({});
Context.displayName = 'InnerHtmlContext';
export function Provider({ children }) {
    const p = useRef(Promise.resolve());
    function addScript(script, placeholder) {
        p.current = p.current.then(function loadScript() {
            return new Promise(function elevioAddScriptInner(res) {
                if (script.src) {
                    // Github Gist
                    if (script.src.match(/gist.github.com/)) {
                        loadGist(script.src, placeholder);
                        res();
                        return;
                    }
                    script.onload = () => res();
                    script.onerror = () => res();
                    placeholder.insertAdjacentElement('afterend', script);
                    return;
                }
                else {
                    placeholder.insertAdjacentElement('afterend', script);
                    res();
                }
            });
        });
    }
    return React.createElement(Context.Provider, { value: { addScript } }, children);
}
Provider.displayName = 'InnerHtmlProvider';
//# sourceMappingURL=InnerHtmlProvider.js.map